import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_SUMMARY_API } from "./apiRoutes";

interface Props {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAdminSummary = async () => {
  return await axiosAuth.get(`${DASHBOARD_PM_SUMMARY_API}`);
};

const useGetPmSummary = ({ queryParams }: Props = {}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-admin-summary"],
    queryFn: () => getAdminSummary(),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPmSummary;
